import { render, staticRenderFns } from "./RitationItem.vue?vue&type=template&id=34a2eaed&"
import script from "./RitationItem.vue?vue&type=script&lang=js&"
export * from "./RitationItem.vue?vue&type=script&lang=js&"
import style0 from "./RitationItem.vue?vue&type=style&index=0&id=34a2eaed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports